export const ROUTES = {
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  SET_PASSWORD: '/set-password',
  DASHBOARD: '/dashboard',
  CAMPAIGNS: '/campaigns',
  CAMPAIGNS_NEW: '/campaigns/new',
  CAMPAIGN_DETAIL: (id: string) => `/campaigns/${id}` as const,
  LEADS: '/leads',
  INBOX: '/inbox',
  OUTREACH: '/outreach',
  OUTREACH_AGENTS: '/outreach/agents',
  OUTREACH_AGENT_DETAIL: (id: string) => `/outreach/agents/${id}` as const,
  OUTREACH_LEADS: '/outreach/leads',
  ENRICHERS: '/enrichers',
  MONITORING: '/monitoring',
  SETTINGS: '/settings',
  SETTINGS_DOMAINS: '/settings/domains',
  SETTINGS_MAIL: '/settings/mail',
  SETTINGS_TEMPLATES: '/settings/templates',
  SETTINGS_HUBSPOT: '/settings/hubspot',
  SETTINGS_BIGQUERY: '/settings/bigquery',
  SETTINGS_FORWARDERS: '/settings/forwarders',
  SETTINGS_LABELS: '/settings/labels',
  SETTINGS_KEYS: '/settings/keys',
} as const;
